export const DeviceInfo = {
  IsMobile: (window.innerWidth < window.innerHeight) ? window.innerWidth <= 600 : window.innerHeight <= 600,
  IsPortrait: window.innerWidth < window.innerHeight,
};